module.exports = __webpack_public_path__ + "static/media/carlton-logo.f5ba3afa.svg";